import React, { useState } from 'react';
import './App.css';

// Translation object
const translations = {
  en: {
    title: "For US Drivers",
    subtitle: "Complete your signup",
    chooseDriverType: "Choose your driver type",
    driverTypeDesc: "What best describes your situation?",
    driver: "Driver",
    driverDesc: "I drive for a company",
    ownerOperator: "Owner Operator",
    ownerOperatorDesc: "I own and operate my truck",
    companyOwner: "Company Owner",
    companyOwnerDesc: "I own multiple trucks",
    truckInfo: "Your Truck Information",
    truckInfoDescSingle: "Tell us about your truck",
    truckInfoDescMultiple: "Tell us about the trucks you own",
    truck: "Truck",
    make: "Make",
    model: "Model",
    year: "Year",
    remove: "Remove",
    addAnotherTruck: "+ Add Another Truck",
    personalInfo: "Personal Information",
    personalInfoDesc: "Tell us about yourself",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    residency: "Status of Residency",
    selectStatus: "Select your status",
    citizen: "U.S. Citizen",
    permanent: "Permanent Resident",
    workVisa: "Work Visa",
    other: "Other",
    phone: "Phone Number",
    location: "Address or State",
    yearsExperience: "Years of Experience",
    yearsExperienceDesc: "How long have you been driving professionally?",
    years: "years",
    moreThan20: "I have more than 20 years of experience",
    detailedExperience: "Detailed Experience",
    detailedExperienceDesc: "How many years of experience do you have with each truck type?",
    flatbed: "Flatbed",
    dryvan: "Dry Van",
    otr: "OTR (Over The Road)",
    local: "Local",
    hazmat: "Hazmat",
    preferredLanguage: "Preferred Language",
    preferredLanguageDesc: "Select your preferred language for communication",
    cdlUpload: "CDL License Upload",
    cdlUploadDesc: "Please upload photos of your Class A CDL license",
    frontCDL: "Front of CDL",
    backCDL: "Back of CDL",
    clickToUpload: "Click to upload",
    fileTypes: "PNG, JPG or PDF",
    review: "Review Your Information",
    reviewDesc: "Please verify all details before submitting",
    driverType: "Driver Type",
    totalExperience: "Total Experience",
    language: "Language",
    cdlLicense: "CDL License",
    front: "Front",
    back: "Back",
    notUploaded: "Not uploaded",
    next: "Next",
    back: "Back",
    submit: "Submit",
    success: "Success!",
    successMsg: "Your signup has been submitted successfully.",
    checkConsole: "Check the console for the submitted data.",
    startOver: "Start Over"
  },
  es: {
    title: "Para Conductores de EE.UU.",
    subtitle: "Completa tu registro",
    chooseDriverType: "Elige tu tipo de conductor",
    driverTypeDesc: "¿Qué te describe mejor?",
    driver: "Conductor",
    driverDesc: "Conduzco para una empresa",
    ownerOperator: "Operador Propietario",
    ownerOperatorDesc: "Poseo y opero mi camión",
    companyOwner: "Dueño de Empresa",
    companyOwnerDesc: "Poseo múltiples camiones",
    truckInfo: "Información de tu Camión",
    truckInfoDescSingle: "Cuéntanos sobre tu camión",
    truckInfoDescMultiple: "Cuéntanos sobre los camiones que posees",
    truck: "Camión",
    make: "Marca",
    model: "Modelo",
    year: "Año",
    remove: "Eliminar",
    addAnotherTruck: "+ Agregar Otro Camión",
    personalInfo: "Información Personal",
    personalInfoDesc: "Cuéntanos sobre ti",
    firstName: "Nombre",
    middleName: "Segundo Nombre",
    lastName: "Apellido",
    residency: "Estado de Residencia",
    selectStatus: "Selecciona tu estado",
    citizen: "Ciudadano de EE.UU.",
    permanent: "Residente Permanente",
    workVisa: "Visa de Trabajo",
    other: "Otro",
    phone: "Número de Teléfono",
    location: "Dirección o Estado",
    yearsExperience: "Años de Experiencia",
    yearsExperienceDesc: "¿Cuánto tiempo has conducido profesionalmente?",
    years: "años",
    moreThan20: "Tengo más de 20 años de experiencia",
    detailedExperience: "Experiencia Detallada",
    detailedExperienceDesc: "¿Cuántos años de experiencia tienes con cada tipo de camión?",
    flatbed: "Plataforma",
    dryvan: "Furgón Seco",
    otr: "OTR (Largas Distancias)",
    local: "Local",
    hazmat: "Materiales Peligrosos",
    preferredLanguage: "Idioma Preferido",
    preferredLanguageDesc: "Selecciona tu idioma preferido para comunicación",
    cdlUpload: "Subir Licencia CDL",
    cdlUploadDesc: "Por favor sube fotos de tu licencia CDL Clase A",
    frontCDL: "Frente de CDL",
    backCDL: "Reverso de CDL",
    clickToUpload: "Haz clic para subir",
    fileTypes: "PNG, JPG o PDF",
    review: "Revisa tu Información",
    reviewDesc: "Por favor verifica todos los detalles antes de enviar",
    driverType: "Tipo de Conductor",
    totalExperience: "Experiencia Total",
    language: "Idioma",
    cdlLicense: "Licencia CDL",
    front: "Frente",
    back: "Reverso",
    notUploaded: "No subido",
    next: "Siguiente",
    back: "Atrás",
    submit: "Enviar",
    success: "¡Éxito!",
    successMsg: "Tu registro ha sido enviado exitosamente.",
    checkConsole: "Revisa la consola para los datos enviados.",
    startOver: "Comenzar de Nuevo"
  },
  ru: {
    title: "Для Водителей США",
    subtitle: "Завершите регистрацию",
    chooseDriverType: "Выберите тип водителя",
    driverTypeDesc: "Что лучше всего вас описывает?",
    driver: "Водитель",
    driverDesc: "Я вожу для компании",
    ownerOperator: "Владелец-Оператор",
    ownerOperatorDesc: "Я владею и управляю своим грузовиком",
    companyOwner: "Владелец Компании",
    companyOwnerDesc: "Я владею несколькими грузовиками",
    truckInfo: "Информация о Грузовике",
    truckInfoDescSingle: "Расскажите о вашем грузовике",
    truckInfoDescMultiple: "Расскажите о грузовиках, которыми вы владеете",
    truck: "Грузовик",
    make: "Марка",
    model: "Модель",
    year: "Год",
    remove: "Удалить",
    addAnotherTruck: "+ Добавить Грузовик",
    personalInfo: "Личная Информация",
    personalInfoDesc: "Расскажите о себе",
    firstName: "Имя",
    middleName: "Отчество",
    lastName: "Фамилия",
    residency: "Статус Резидентства",
    selectStatus: "Выберите ваш статус",
    citizen: "Гражданин США",
    permanent: "Постоянный Резидент",
    workVisa: "Рабочая Виза",
    other: "Другое",
    phone: "Номер Телефона",
    location: "Адрес или Штат",
    yearsExperience: "Годы Опыта",
    yearsExperienceDesc: "Как долго вы профессионально водите?",
    years: "лет",
    moreThan20: "У меня более 20 лет опыта",
    detailedExperience: "Детальный Опыт",
    detailedExperienceDesc: "Сколько лет опыта у вас с каждым типом грузовика?",
    flatbed: "Платформа",
    dryvan: "Фургон",
    otr: "OTR (Дальние Рейсы)",
    local: "Местные",
    hazmat: "Опасные Грузы",
    preferredLanguage: "Предпочитаемый Язык",
    preferredLanguageDesc: "Выберите предпочитаемый язык для общения",
    cdlUpload: "Загрузка CDL Лицензии",
    cdlUploadDesc: "Пожалуйста, загрузите фото вашей CDL лицензии класса A",
    frontCDL: "Лицевая сторона CDL",
    backCDL: "Обратная сторона CDL",
    clickToUpload: "Нажмите для загрузки",
    fileTypes: "PNG, JPG или PDF",
    review: "Проверьте Информацию",
    reviewDesc: "Пожалуйста, проверьте все детали перед отправкой",
    driverType: "Тип Водителя",
    totalExperience: "Общий Опыт",
    language: "Язык",
    cdlLicense: "CDL Лицензия",
    front: "Лицевая",
    back: "Обратная",
    notUploaded: "Не загружено",
    next: "Далее",
    back: "Назад",
    submit: "Отправить",
    success: "Успешно!",
    successMsg: "Ваша регистрация успешно отправлена.",
    checkConsole: "Проверьте консоль для отправленных данных.",
    startOver: "Начать Заново"
  },
  tr: {
    title: "ABD Sürücüleri İçin",
    subtitle: "Kaydınızı tamamlayın",
    chooseDriverType: "Sürücü tipinizi seçin",
    driverTypeDesc: "Sizi en iyi hangisi tanımlıyor?",
    driver: "Sürücü",
    driverDesc: "Bir şirket için sürüyorum",
    ownerOperator: "Mal Sahibi Operatör",
    ownerOperatorDesc: "Kendi kamyonumu sahibim ve kullanıyorum",
    companyOwner: "Şirket Sahibi",
    companyOwnerDesc: "Birden fazla kamyona sahibim",
    truckInfo: "Kamyon Bilgileriniz",
    truckInfoDescSingle: "Kamyonunuz hakkında bize bilgi verin",
    truckInfoDescMultiple: "Sahip olduğunuz kamyonlar hakkında bize bilgi verin",
    truck: "Kamyon",
    make: "Marka",
    model: "Model",
    year: "Yıl",
    remove: "Kaldır",
    addAnotherTruck: "+ Başka Kamyon Ekle",
    personalInfo: "Kişisel Bilgiler",
    personalInfoDesc: "Kendiniz hakkında bize bilgi verin",
    firstName: "Ad",
    middleName: "İkinci Ad",
    lastName: "Soyad",
    residency: "İkamet Durumu",
    selectStatus: "Durumunuzu seçin",
    citizen: "ABD Vatandaşı",
    permanent: "Daimi İkamet",
    workVisa: "Çalışma Vizesi",
    other: "Diğer",
    phone: "Telefon Numarası",
    location: "Adres veya Eyalet",
    yearsExperience: "Deneyim Yılları",
    yearsExperienceDesc: "Ne kadar süredir profesyonel olarak sürüyorsunuz?",
    years: "yıl",
    moreThan20: "20 yıldan fazla deneyimim var",
    detailedExperience: "Detaylı Deneyim",
    detailedExperienceDesc: "Her kamyon tipi ile kaç yıl deneyiminiz var?",
    flatbed: "Açık Kasa",
    dryvan: "Kapalı Kasa",
    otr: "OTR (Uzun Yol)",
    local: "Yerel",
    hazmat: "Tehlikeli Madde",
    preferredLanguage: "Tercih Edilen Dil",
    preferredLanguageDesc: "İletişim için tercih ettiğiniz dili seçin",
    cdlUpload: "CDL Lisans Yükle",
    cdlUploadDesc: "Lütfen A Sınıfı CDL lisansınızın fotoğraflarını yükleyin",
    frontCDL: "CDL Ön Yüz",
    backCDL: "CDL Arka Yüz",
    clickToUpload: "Yüklemek için tıklayın",
    fileTypes: "PNG, JPG veya PDF",
    review: "Bilgilerinizi Gözden Geçirin",
    reviewDesc: "Lütfen göndermeden önce tüm detayları doğrulayın",
    driverType: "Sürücü Tipi",
    totalExperience: "Toplam Deneyim",
    language: "Dil",
    cdlLicense: "CDL Lisansı",
    front: "Ön",
    back: "Arka",
    notUploaded: "Yüklenmedi",
    next: "İleri",
    back: "Geri",
    submit: "Gönder",
    success: "Başarılı!",
    successMsg: "Kaydınız başarıyla gönderildi.",
    checkConsole: "Gönderilen veriler için konsolu kontrol edin.",
    startOver: "Yeniden Başla"
  }
};

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [formData, setFormData] = useState({
    driverType: null,
    trucks: [{ make: '', model: '', year: '' }],
    name: { first: '', middle: '', last: '' },
    residencyStatus: '',
    phone: '',
    location: { addressOrState: '' },
    experienceYears: 0,
    isExperiencePlus: false,
    detailedExperience: { flatbed: 0, dryvan: 0, otr: 0, local: 0, hazmat: 0 },
    language: null,
    cdlUploads: { front: null, back: null }
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Get step numbers that should actually be shown
  const getVisibleSteps = () => {
    const steps = [1]; // Driver type selection
    
    // Truck details for owner operator and company owner
    if (formData.driverType === 'Owner Operator' || formData.driverType === 'Company Owner') {
      steps.push(2);
    }
    
    // All drivers get these steps
    steps.push(3, 4, 5, 6, 7, 8); // Personal, Experience, Detailed Exp, Language, CDL, Review
    
    return steps;
  };

  const isStepValid = () => {
    switch (currentStep) {
      case 1:
        return formData.driverType !== null;
      case 2:
        // Truck details validation for owner operator and company owner
        return formData.trucks.every(truck => 
          truck.make.trim() !== '' && 
          truck.model.trim() !== '' && 
          truck.year.trim() !== ''
        );
      case 3:
        return (
          formData.name.first.trim() !== '' &&
          formData.name.last.trim() !== '' &&
          formData.residencyStatus !== '' &&
          formData.phone.trim() !== '' &&
          formData.location.addressOrState.trim() !== ''
        );
      case 4:
        return true; // Experience slider always valid
      case 5:
        return true; // Detailed experience can be 0
      case 6:
        return formData.language !== null;
      case 7:
        return formData.cdlUploads.front !== null && formData.cdlUploads.back !== null;
      case 8:
        return true; // Review page
      default:
        return false;
    }
  };

  const handleNext = () => {
    if (!isStepValid()) return;
    
    const visibleSteps = getVisibleSteps();
    const currentIndex = visibleSteps.indexOf(currentStep);
    
    if (currentIndex < visibleSteps.length - 1) {
      setCurrentStep(visibleSteps[currentIndex + 1]);
    }
  };

  const handleBack = () => {
    const visibleSteps = getVisibleSteps();
    const currentIndex = visibleSteps.indexOf(currentStep);
    
    if (currentIndex > 0) {
      setCurrentStep(visibleSteps[currentIndex - 1]);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setSubmitError(null);

    const payload = {
      driverType: formData.driverType,
      name: formData.name,
      residencyStatus: formData.residencyStatus,
      phone: formData.phone,
      location: formData.location,
      experienceYears: formData.isExperiencePlus ? '20+' : formData.experienceYears,
      detailedExperience: formData.detailedExperience,
      language: formData.language,
      cdlUploads: {
        front: formData.cdlUploads.front?.name || null,
        back: formData.cdlUploads.back?.name || null
      },
      ...(formData.driverType !== 'Driver' && {
        trucks: formData.trucks
      })
    };
    
    console.log('Form Submission:', payload);

    try {
      // Use relative URL - nginx will proxy /api to backend
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/api/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.success) {
        console.log('Successfully submitted to Google Sheets');
        setShowSuccess(true);
      } else {
        throw new Error(result.error || 'Submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileChange = (side, file) => {
    setFormData(prev => ({
      ...prev,
      cdlUploads: { ...prev.cdlUploads, [side]: file }
    }));
  };

  const visibleSteps = getVisibleSteps();
  const currentStepIndex = visibleSteps.indexOf(currentStep);
  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStepIndex === visibleSteps.length - 1;

  if (showSuccess) {
    return (
      <div className="app">
        <div className="success-container">
          <div className="success-icon">✓</div>
          <h1>{translations[currentLanguage].success}</h1>
          <p>{translations[currentLanguage].successMsg}</p>
          
          <button 
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            {translations[currentLanguage].startOver}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="wizard-container">
        <LanguageSwitcher 
          currentLanguage={currentLanguage} 
          setCurrentLanguage={setCurrentLanguage} 
        />
        <div className="wizard-header">
          <h1>{translations[currentLanguage].title}</h1>
          <p>{translations[currentLanguage].subtitle}</p>
        </div>

        <ProgressIndicator 
          steps={visibleSteps.length} 
          currentStep={currentStepIndex + 1} 
        />

        <div className="step-container">
          {currentStep === 1 && (
            <StepOne formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 2 && (
            <StepTwo formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 3 && (
            <StepThree formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 4 && (
            <StepFour formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 5 && (
            <StepFive formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 6 && (
            <StepSix formData={formData} setFormData={setFormData} t={translations[currentLanguage]} />
          )}
          {currentStep === 7 && (
            <StepSeven formData={formData} handleFileChange={handleFileChange} t={translations[currentLanguage]} />
          )}
          {currentStep === 8 && (
            <ReviewStep formData={formData} t={translations[currentLanguage]} />
          )}
        </div>

        <div className="wizard-actions">
          {!isFirstStep && (
            <button className="btn btn-secondary" onClick={handleBack}>
              {translations[currentLanguage].back}
            </button>
          )}
          <div className="spacer"></div>
          {!isLastStep ? (
            <button 
              className="btn btn-primary" 
              onClick={handleNext}
              disabled={!isStepValid()}
            >
              {translations[currentLanguage].next}
            </button>
          ) : (
            <button 
              className="btn btn-primary" 
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : translations[currentLanguage].submit}
            </button>
          )}
        </div>

        {submitError && (
          <div style={{ 
            marginTop: '20px', 
            padding: '15px', 
            backgroundColor: '#fee', 
            color: '#c33', 
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            ❌ Error: {submitError}
          </div>
        )}
      </div>
    </div>
  );
}

function LanguageSwitcher({ currentLanguage, setCurrentLanguage }) {
  const [isOpen, setIsOpen] = React.useState(false);
  
  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'es', label: 'ES' },
    { code: 'ru', label: 'RU' },
    { code: 'tr', label: 'TR' }
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage);

  const handleSelect = (code) => {
    setCurrentLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher">
      <button
        className="language-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        {currentLang?.label}
      </button>
      {isOpen && (
        <div className="language-dropdown">
          {languages.map(lang => (
            <button
              key={lang.code}
              className={`language-option ${currentLanguage === lang.code ? 'active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function ProgressIndicator({ steps, currentStep }) {
  return (
    <div className="progress-indicator">
      {Array.from({ length: steps }, (_, i) => (
        <div
          key={i}
          className={`progress-dot ${i + 1 <= currentStep ? 'active' : ''} ${
            i + 1 === currentStep ? 'current' : ''
          }`}
        >
          {i + 1 < currentStep && <span className="checkmark">✓</span>}
        </div>
      ))}
    </div>
  );
}

function StepOne({ formData, setFormData, t }) {
  const driverTypes = [
    { value: 'Driver', label: t.driver, icon: '🚗', description: t.driverDesc },
    { value: 'Owner Operator', label: t.ownerOperator, icon: '👤', description: t.ownerOperatorDesc },
    { value: 'Company Owner', label: t.companyOwner, icon: '🏢', description: t.companyOwnerDesc }
  ];

  return (
    <div className="step-content fade-in">
      <h2>{t.chooseDriverType}</h2>
      <p className="step-description">{t.driverTypeDesc}</p>
      <div className="driver-type-grid">
        {driverTypes.map((type) => (
          <button
            key={type.value}
            className={`driver-type-card ${formData.driverType === type.value ? 'selected' : ''}`}
            onClick={() => setFormData({ ...formData, driverType: type.value })}
          >
            <div className="driver-type-icon">{type.icon}</div>
            <h3>{type.label}</h3>
            <p>{type.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}

function StepTwo({ formData, setFormData, t }) {
  const addTruck = () => {
    setFormData(prev => ({
      ...prev,
      trucks: [...prev.trucks, { make: '', model: '', year: '' }]
    }));
  };

  const removeTruck = (index) => {
    if (formData.trucks.length > 1) {
      setFormData(prev => ({
        ...prev,
        trucks: prev.trucks.filter((_, i) => i !== index)
      }));
    }
  };

  const updateTruck = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      trucks: prev.trucks.map((truck, i) => 
        i === index ? { ...truck, [field]: value } : truck
      )
    }));
  };

  const isCompanyOwner = formData.driverType === 'Company Owner';

  return (
    <div className="step-content fade-in">
      <h2>{t.truckInfo}</h2>
      <p className="step-description">
        {isCompanyOwner 
          ? t.truckInfoDescMultiple
          : t.truckInfoDescSingle}
      </p>
      
      <div className="trucks-container">
        {formData.trucks.map((truck, index) => (
          <div key={index} className="truck-form">
            <div className="truck-form-header">
              <h3>Truck {index + 1}</h3>
              {isCompanyOwner && formData.trucks.length > 1 && (
                <button
                  type="button"
                  className="btn-remove-truck"
                  onClick={() => removeTruck(index)}
                >
                  ✕ {t.remove}
                </button>
              )}
            </div>
            
            <div className="truck-fields">
              <div className="form-group">
                <label htmlFor={`make-${index}`}>{t.make} *</label>
                <input
                  id={`make-${index}`}
                  type="text"
                  value={truck.make}
                  onChange={(e) => updateTruck(index, 'make', e.target.value)}
                  placeholder="Freightliner"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor={`model-${index}`}>{t.model} *</label>
                <input
                  id={`model-${index}`}
                  type="text"
                  value={truck.model}
                  onChange={(e) => updateTruck(index, 'model', e.target.value)}
                  placeholder="Cascadia"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor={`year-${index}`}>{t.year} *</label>
                <input
                  id={`year-${index}`}
                  type="text"
                  value={truck.year}
                  onChange={(e) => updateTruck(index, 'year', e.target.value)}
                  placeholder="2020"
                  required
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {isCompanyOwner && (
        <button
          type="button"
          className="btn-add-truck"
          onClick={addTruck}
        >
          + {t.addAnotherTruck}
        </button>
      )}
    </div>
  );
}

function StepThree({ formData, setFormData, t }) {
  const updateName = (field, value) => {
    setFormData(prev => ({
      ...prev,
      name: { ...prev.name, [field]: value }
    }));
  };

  const updateLocation = (value) => {
    setFormData(prev => ({
      ...prev,
      location: { addressOrState: value }
    }));
  };

  return (
    <div className="step-content fade-in">
      <h2>{t.personalInfo}</h2>
      <p className="step-description">{t.personalInfoDesc}</p>
      
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="firstName">{t.firstName} *</label>
          <input
            id="firstName"
            type="text"
            value={formData.name.first}
            onChange={(e) => updateName('first', e.target.value)}
            placeholder="John"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="middleName">{t.middleName}</label>
          <input
            id="middleName"
            type="text"
            value={formData.name.middle}
            onChange={(e) => updateName('middle', e.target.value)}
            placeholder="Michael"
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastName">{t.lastName} *</label>
          <input
            id="lastName"
            type="text"
            value={formData.name.last}
            onChange={(e) => updateName('last', e.target.value)}
            placeholder="Doe"
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="residency">{t.residency} *</label>
        <select
          id="residency"
          value={formData.residencyStatus}
          onChange={(e) => setFormData({ ...formData, residencyStatus: e.target.value })}
          required
        >
          <option value="">{t.selectStatus}</option>
          <option value="citizen">{t.citizen}</option>
          <option value="permanent">{t.permanentResident}</option>
          <option value="work-visa">{t.workVisa}</option>
          <option value="other">{t.other}</option>
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="phone">{t.phone} *</label>
        <input
          id="phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="(555) 123-4567"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="location">{t.location} *</label>
        <input
          id="location"
          type="text"
          value={formData.location.addressOrState}
          onChange={(e) => updateLocation(e.target.value)}
          placeholder="123 Main St, City, State or just State"
          required
        />
      </div>
    </div>
  );
}

function StepFour({ formData, setFormData, t }) {
  const handleSliderChange = (e) => {
    const value = parseFloat(e.target.value);
    setFormData(prev => ({
      ...prev,
      experienceYears: value,
      isExperiencePlus: value >= 20 ? prev.isExperiencePlus : false
    }));
  };

  const togglePlus = () => {
    setFormData(prev => ({
      ...prev,
      isExperiencePlus: !prev.isExperiencePlus
    }));
  };

  const displayValue = formData.isExperiencePlus ? '20+' : formData.experienceYears;

  return (
    <div className="step-content fade-in">
      <h2>{t.experience}</h2>
      <p className="step-description">{t.experienceDesc}</p>
      
      <div className="experience-container">
        <div className="experience-display">
          <span className="experience-value">{displayValue}</span>
          <span className="experience-label">{t.years}</span>
        </div>

        <input
          type="range"
          min="0"
          max="20"
          step="0.5"
          value={formData.experienceYears}
          onChange={handleSliderChange}
          className="experience-slider"
        />

        <div className="slider-labels">
          <span>0</span>
          <span>10</span>
          <span>20</span>
        </div>

        {formData.experienceYears >= 20 && (
          <div className="plus-toggle">
            <label>
              <input
                type="checkbox"
                checked={formData.isExperiencePlus}
                onChange={togglePlus}
              />
              <span>{t.moreThan20}</span>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

function StepFive({ formData, setFormData, t }) {
  const truckTypes = [
    { key: 'flatbed', label: t.flatbed },
    { key: 'dryvan', label: t.dryvan },
    { key: 'otr', label: t.otr },
    { key: 'local', label: t.local },
    { key: 'hazmat', label: t.hazmat }
  ];

  const updateDetailedExperience = (key, value) => {
    const numValue = parseFloat(value) || 0;
    const clampedValue = Math.min(Math.max(numValue, 0), 20);
    
    setFormData(prev => ({
      ...prev,
      detailedExperience: {
        ...prev.detailedExperience,
        [key]: clampedValue
      }
    }));
  };

  return (
    <div className="step-content fade-in">
      <h2>{t.detailedExperience}</h2>
      <p className="step-description">{t.detailedExperienceDesc}</p>
      
      <div className="detailed-experience-list">
        {truckTypes.map((type) => (
          <div key={type.key} className="experience-item">
            <label htmlFor={type.key}>{type.label}</label>
            <div className="experience-input-group">
              <input
                id={type.key}
                type="number"
                min="0"
                max="20"
                step="0.5"
                value={formData.detailedExperience[type.key]}
                onChange={(e) => updateDetailedExperience(type.key, e.target.value)}
              />
              <span className="input-suffix">{t.years}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function StepSix({ formData, setFormData, t }) {
  const languages = [
    { value: 'English', flag: '🇺🇸' },
    { value: 'Spanish', flag: '🇪🇸' },
    { value: 'Turkish', flag: '🇹🇷' },
    { value: 'Russian', flag: '🇷🇺' },
    { value: 'Hindi', flag: '🇮🇳' }
  ];

  return (
    <div className="step-content fade-in">
      <h2>{t.preferredLanguage}</h2>
      <p className="step-description">{t.preferredLanguageDesc}</p>
      
      <div className="language-grid">
        {languages.map((lang) => (
          <button
            key={lang.value}
            className={`language-pill ${formData.language === lang.value ? 'selected' : ''}`}
            onClick={() => setFormData({ ...formData, language: lang.value })}
          >
            <span className="language-flag">{lang.flag}</span>
            <span className="language-name">{lang.value}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function StepSeven({ formData, handleFileChange, t }) {
  const handleFileSelect = (side, e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileChange(side, file);
    }
  };

  const FileUploadBox = ({ side, file }) => {
    const sideLabel = side === 'front' ? t.frontCDL : t.backCDL;
    
    return (
      <div className="file-upload-box">
        <h3>{sideLabel}</h3>
        <label htmlFor={`cdl-${side}`} className="file-upload-label">
          {file ? (
            <div className="file-preview">
              <div className="file-icon">📄</div>
              <div className="file-name">{file.name}</div>
              <div className="file-size">{(file.size / 1024).toFixed(1)} KB</div>
            </div>
          ) : (
            <div className="file-placeholder">
              <div className="upload-icon">📁</div>
              <p>{t.clickToUpload}</p>
              <span>{t.fileTypes}</span>
            </div>
          )}
          <input
            id={`cdl-${side}`}
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => handleFileSelect(side, e)}
            style={{ display: 'none' }}
          />
        </label>
      </div>
    );
  };

  return (
    <div className="step-content fade-in">
      <h2>{t.cdlUpload}</h2>
      <p className="step-description">{t.cdlUploadDesc}</p>
      
      <div className="cdl-upload-grid">
        <FileUploadBox side="front" file={formData.cdlUploads.front} />
        <FileUploadBox side="back" file={formData.cdlUploads.back} />
      </div>
    </div>
  );
}

function ReviewStep({ formData, t }) {
  return (
    <div className="step-content fade-in">
      <h2>{t.reviewInfo}</h2>
      <p className="step-description">{t.reviewInfoDesc}</p>
      
      <div className="review-sections">
        <div className="review-section">
          <h3>{t.driverTypeLabel}</h3>
          <p>{formData.driverType}</p>
        </div>

        {formData.driverType !== 'Driver' && (
          <div className="review-section">
            <h3>{t.truckInfo}</h3>
            {formData.trucks.map((truck, index) => (
              <p key={index}>
                <strong>Truck {index + 1}:</strong> {truck.year} {truck.make} {truck.model}
              </p>
            ))}
          </div>
        )}

        <div className="review-section">
          <h3>{t.personalInfo}</h3>
          <p><strong>{t.name}:</strong> {formData.name.first} {formData.name.middle} {formData.name.last}</p>
          <p><strong>{t.residency}:</strong> {formData.residencyStatus}</p>
          <p><strong>{t.phone}:</strong> {formData.phone}</p>
          <p><strong>{t.location}:</strong> {formData.location.addressOrState}</p>
        </div>

        <div className="review-section">
          <h3>{t.experience}</h3>
          <p><strong>{t.totalExperience}:</strong> {formData.isExperiencePlus ? '20+' : formData.experienceYears} {t.years}</p>
        </div>

        <div className="review-section">
          <h3>{t.detailedExperience}</h3>
          <p><strong>{t.flatbed}:</strong> {formData.detailedExperience.flatbed} {t.years}</p>
          <p><strong>{t.dryvan}:</strong> {formData.detailedExperience.dryvan} {t.years}</p>
          <p><strong>{t.otr}:</strong> {formData.detailedExperience.otr} {t.years}</p>
          <p><strong>{t.local}:</strong> {formData.detailedExperience.local} {t.years}</p>
          <p><strong>{t.hazmat}:</strong> {formData.detailedExperience.hazmat} {t.years}</p>
        </div>

        <div className="review-section">
          <h3>{t.preferredLanguage}</h3>
          <p>{formData.language}</p>
        </div>

        <div className="review-section">
          <h3>{t.cdlLicense}</h3>
          <p><strong>{t.frontCDL}:</strong> {formData.cdlUploads.front?.name || t.notUploaded}</p>
          <p><strong>{t.backCDL}:</strong> {formData.cdlUploads.back?.name || t.notUploaded}</p>
        </div>
      </div>
    </div>
  );
}

export default App;
